import { render } from "./InfraService.vue?vue&type=template&id=cc691d6c&scoped=true"
import script from "./InfraService.vue?vue&type=script&lang=js"
export * from "./InfraService.vue?vue&type=script&lang=js"

import "./InfraService.vue?vue&type=style&index=0&id=cc691d6c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc691d6c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
